import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";
import { topLayerOptions } from "../lib/top_layer_tooltip";

export default class extends Controller {
  async copy(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const { text, selector } = event.params;

    let content;
    if (text != null) {
      content = text;
    } else if (selector) {
      const element = document.querySelector(selector);
      if (!element) {
        console.error("Element not found:", selector);
        this.showTooltip(target, "Failed to copy");
        return;
      }
      content = element.value || element.textContent;
    } else {
      console.error(
        "Clipboard controller: missing data-clipboard-text-param or data-clipboard-selector-param",
      );
      this.showTooltip(target, "Failed to copy");
      return;
    }

    try {
      await navigator.clipboard.writeText(content);
      this.showTooltip(target, "Copied!");
    } catch (err) {
      console.error("Failed to copy to clipboard:", err);
      this.showTooltip(target, "Failed to copy");
    }
  }

  async copyFromResponse(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const url = target.href;
    const dropdownElement = target.closest(".dropdown-component");
    const element = dropdownElement || target;

    try {
      // For Safari: initiate clipboard write synchronously with a promise
      // This maintains the user gesture context
      // Note: Clipboard API only supports text/plain, text/html, and image/png
      const clipboardItem = new ClipboardItem({
        "text/plain": fetch(url).then(async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
          }
          // Rebuild the blob with a bare MIME type. response.blob() inherits
          // the full Content-Type header ("text/plain;charset=utf-8"), and
          // Firefox requires it to match the ClipboardItem key exactly.
          return new Blob([await response.text()], { type: "text/plain" });
        }),
      });

      await navigator.clipboard.write([clipboardItem]);

      this.showTooltip(element, "Copied!");
    } catch (err) {
      console.error("Failed to copy to clipboard:", err);
      this.showTooltip(element, "Failed to copy");
    }
  }

  showTooltip(element, content) {
    element.dataset.clipboardActive = true;
    tippy(element, {
      ...topLayerOptions,
      content: content,
      showOnCreate: true,
      trigger: "manual",
      hideOnClick: true,
      onShown(tip) {
        setTimeout(() => tip.hide(), 2000);
      },
      onHidden(tip) {
        delete element.dataset.clipboardActive;
        tip.destroy();
      },
    });
  }
}
